<template>
  <div id='app'>
    <div v-show="loading">
      <p>Now loading...
      <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
      </p>
    </div>
    <div v-show="!loading" >
    <v-toolbar flat color="white">
      <v-toolbar-title data-app>宛先選択</v-toolbar-title>
      <v-divider class="mx-5" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="destinations"
      item-key="companyName"
      select-all
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>
          <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
        </td>
        <td>{{ props.item.companyName }}</td>
        <td class="text-xs-left">{{ props.item.staffName }}</td>
        <td class="text-xs-left">{{ props.item.mail }}</td>
        <td class="text-xs-left">{{ props.item.note }}</td>
      </template>
    </v-data-table>
    <div class="text-xs-right">
    <v-btn color="primary" dark @click="check">
      送信
    </v-btn>
    <v-dialog v-model="dialog" max-width="425">
      <v-card>
        <v-card-title class="headline">メールを送信してよろしいですか？</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">
            いいえ
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="sendmail">
            はい
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div> 
    </div>   
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store.js'

export default {

  data() {
    return {
      loading:true,
      dialog: false,
      selected: [],
      headers: [
        {
          text: '企業名',
          align: 'left',
          sortable: false,
          value: 'companyName'
        },
        { text: '担当者名', value: 'staffName' },
        { text: 'メールアドレス', value: 'mail' },
        { text: '備考', value: 'note' }
      ],
      destinations: []
    }
  },
  created() {
    const self = this
        axios
          .get(
            'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/master/destination/list',
            {
              headers:{
                'Authorization':sessionStorage.getItem('Authorization')
              }
            }
          )
          .then(response => {
            self.destinations = response.data
            self.loading = false
            console.log('aaaaaaaaaaa'+store.state.mailBody)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
  methods:{
    sendmail(){
      
 //console.log('aaa'+store.state.mailBody)
      store.commit('mutationType', {
        mailTitle: store.state.mailTitle,
        mailBody:store.state.mailBody,
        destinations:this.selected,
        replyTo: store.state.replyTo,
        userId:store.state.userId
      })
     // console.log(store.state.mailBody)
      console.log(store.state.destinations)
      this.$router.push('/Completion')
      },
    check (){
      if( (this.selected.length)==0){
         alert('チェックを入れてください')
      } else{
        this.dialog = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
p {
  text-align: center;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Destination.vue